// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"b70eb759","188":"1d722160","199":"f719986e","504":"b2404d0f","655":"3a34701e","986":"134974d1"}[chunkId] + ".chunk.css";
};